import "vite/modulepreload-polyfill";
import React from "react";
import ReactDOM from "react-dom/client";
import Attendance from "../components/Attendance";

const rootElement = document.getElementById("campaign-attendance");

if (rootElement) {
  const customerId = rootElement.getAttribute("data-customer-id");
  const date = rootElement.getAttribute("data-date");
  const available = rootElement.getAttribute("data-available") === "true";
  const token = rootElement.getAttribute("data-token");
  const primaryActionLabel = rootElement.getAttribute(
    "data-primary-action-label"
  );
  const primaryActionUrl = rootElement.getAttribute("data-primary-action-url");

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <Attendance
        customerId={customerId}
        date={date}
        token={token}
        available={available}
        primaryAction={
          primaryActionLabel && primaryActionUrl
            ? {
                label: primaryActionLabel,
                url: primaryActionUrl,
              }
            : null
        }
      />
    </React.StrictMode>
  );
}